import { DtoFilesPostRes } from "./abst/DtoFilesPostRes";

export class DtoFilesPostResImple extends DtoFilesPostRes {
  public url: string | null = null;
}
